let config = null;

module.exports.initialize = async () => {
  if (config === null) {
    config = await fetch("/config.json").then((res) => res.json());
  }

  module.exports = config;
};
